import { LOCALE } from "@/utils/constants";

export const getBrowserLocale = () => {
  return navigator.language.split("-")[0].toLowerCase() as LOCALE;
};

export const getAppLocale = (queryLocale: string | undefined) => {
  if (queryLocale === "de") return LOCALE.DE;
  return LOCALE.EN;
};
